<template>
  <div class="step-two">
    <div class="idea-block__title">
      {{ title }}
    </div>

    <div class="idea-block__description idea-block__description_small">
      {{ description }}
    </div>
    <form
      ref="form2"
      novalidate
      class="step-two__body"
      @submit.prevent="submitForm"
    >
      <div class="step-two__form-info">
        Всі поля з зірочкою обов’язкові
      </div>

      <BaseInput
        v-model="name"
        type="text"
        name="name"
        errorMsg="Мають бути лише літери"
        placeholder="*Ваші прізвище та ім’я"
        @error="addError"
      />

      <div class="step-two__row">
        <div class="step-two__col">
          <BaseInput
            v-model="email"
            type="email"
            name="email"
            errorMsg="Поле заповнене некоректно"
            placeholder="*Email"
            @error="addError"
          />
        </div>

        <div class="step-two__col">
          <BasePhone
            v-model="phone"
            type="tel"
            name="phone"
            placeholder="+380"
          />
        </div>
      </div>

      <div class="step-two__row">
        <div class="step-two__col">
          <BaseInput
            v-model="profession"
            type="text"
            name="profession"
            errorMsg="Мають бути лише літери"
            placeholder="*Професія"
            @error="addError"
          />
        </div>

        <div class="step-two__col">
          <BaseInput
            v-model="city"
            type="text"
            name="city"
            placeholder="Місто"
          />
        </div>
      </div>

      <BaseCheckbox
        v-model="agreement"
        class="step-two__agreement"
        label="Надаю свій дозвіл на використання авторського матеріалу"
      />

      <BaseCheckbox
        v-model="privacy"
        class="step-two__privacy"
        :label="`Погоджуюсь з <a href='./privacy-policy.pdf' target='_blank'> політикою конфіденційності<a/>`"
      />

      <div class="step-two__btn">
        <BaseButton
          :disabled="!isValid"
          type="sumbit"
          :class="{'button_disabled':isDisabled}"
        >
          Поділитися ідеєю
        </BaseButton>

        <div class="step-two__btn-info">
          Натискаючи кнопку, ви даєте згоду на <a href="./privacy-policy.pdf" target="_blank"> обробку персональних даних<a />
          </a>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import $axios from '@/plugins/axios'
  export default {
    name: 'StepTwo',

    props: {
      title: {
        type: String,
        default: ''
      },
      description: {
        type: String,
        default: ''
      },
      clearStepTwo: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        name: null,
        email: null,
        phone: null,
        profession: null,
        city: null,
        agreement: false,
        privacy: false,
        errors: false,
        isEmpty: true,
        token: null,
        isDisabled: false

      }
    },

    computed: {
      isValid () {
        return !!(!this.errors && this.agreement && this.privacy)
      }
    },

    created () {
      this.$axios = $axios
      this.requestUrl = `${process.env.VUE_APP_API}`
    },

    methods: {
      addError (e) {
        // console.log(e)
        this.errors = e
      },

      submitForm (e) {
        const body = new FormData()

        body.append('LastFirstName', this.name)
        body.append('Email', this.email)
        body.append('Profession', this.profession)
        body.append('PhoneNumber', this.phone)
        body.append('City', this.city)

        this.post(body)
      },
      async post (body) {
        this.isDisabled = true
        await this.$axios.post(`${this.requestUrl}/idea-form/send-ideas`, body)
          .then(response => {
            this.token = response.data.guid
            this.$emit('sendForm', this.token)
            this.isDisabled = false
          })
          .catch(error => {
            console.log(error)
            this.errored = true
            this.loading = true
          })
          .finally(() => {
            // console.log('isready')
          })
      }
    }

  }
</script>

<style lang="scss">
.step-two {
  position: relative;
  width: 100%;
  max-width: 699px;
  margin: 0 auto;

  &__form-info {
    font-size: 18px;
    line-height: 1.34;
    color: #686868;
    margin-top: 22px;
    margin-bottom: 6px;
  }

  &__row {
    display: flex;
    justify-content: space-between;
    margin-top: 26px;

    @include mobile {
      flex-wrap: wrap;
      margin-top: 16px;
    }
  }

  &__col {
    width: calc(50% - 10px);

    @include mobile {
      width: 100%;

      &:not(:last-child) {
        margin-bottom: 16px;
      }
    }
  }

  &__agreement {
    margin-top: 55px;
    margin-bottom: 14px;

    @include mobile {
      margin-top: 24px;
    }
  }

  &__privacy {
    margin-bottom: 30px;
  }

  &__btn {
    display: flex;
    justify-content: space-between;
    align-items: center;

    @include mobile {
      flex-wrap: wrap;
    }

    &-info {
      font-size: 14px;
      line-height: 1.25;
      width: 100%;
      max-width: 318px;

      @include mobile {
        margin-top: 24px;
        text-align: center;
        max-width: 100%;
      }

      a {
        font-size: 14px;
        line-height: 1.25;
        color: $c-yellow;
        transition: 0.3s;
        display: block;

        @include hover {
          text-decoration: none;
        }
      }
    }
  }
}
</style>
